import React, { useState } from "react";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import {
  Button,
  Tooltip,
} from "@material-ui/core";
import config from "../../config";
import Modal from "../Modal";
import { useAuth } from "../../context/Auth";
import EmployeesSelect from "../EmployeesSelect";
import Employee from "../../entities/Employee";

const AddParticipant = ({ eventId, setReload }: any) => {
  const [open, setOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const { fetchWithUser } = useAuth()

  const create = () => {
    const url = `${config.apiUrl}/HolidayGift/AddEmployeesToGiftEvent?eventID=${eventId}`;
    fetchWithUser(url, {
      method: 'POST',
      body: JSON.stringify(selectedIds),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then((_) => {
        setReload(true);
        setOpen(false)
      });
  };

  return (
    <>
      <Tooltip title="Adds single participant" placement="top">
        <Button
          variant="contained"
          disableElevation
          size="medium"
          color="primary"
          onClick={() => setOpen(true)}
        >
          <PersonAddIcon />
          Add Single
        </Button>
      </Tooltip>
      <Modal
        title="Add Participant"
        open={open}
        onSave={create}
        maxWidth="lg"
        fullWidth={true}
        onClose={() => setOpen(false)}
      >
        <EmployeesSelect onChange={(employees: Employee[]) => setSelectedIds(employees.map(e => e.employeeID))} />
      </Modal>
    </>
  );
};

export default AddParticipant;
